import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { UserTermsDataModel } from '@models/user-terms-data-model';
import { plainToClass } from 'class-transformer';
import { BehaviorSubject } from 'rxjs';
import { HttpService } from './http.service';

@Injectable({
	providedIn: 'root'
})
export class TermsService {

	termsAccepted: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

	constructor(private httpService: HttpService,
	) {
	}

	public async getUserTermsSignedData(customerNo?: string): Promise<UserTermsDataModel> {
		let url = `${environment.dataUrl}/terms?customerNo=${customerNo}`;
		const result: UserTermsDataModel = await this.httpService.getDataWithOfflineCheck<UserTermsDataModel>(url);

		let model = plainToClass(UserTermsDataModel, result);
		this.termsAccepted.next(model.TermsSigned);
		return model;
	}

	public async getTermsUrl(version: string): Promise<string> {
		let url = `${environment.dataUrl}/terms/uribyversion/${version}.pdf`;
		const result = await this.httpService.getDataWithOfflineCheck<string>(url, { responseType: 'text' });
		return result;
	}

	public async acceptUserTerms(contactcode: string | undefined, version: string): Promise<void> {
		let url = `${environment.dataUrl}/terms/accept?contactCode=${contactcode}&version=${version}`;
		await this.httpService.postWithOfflineHandling<void>(url, {});

		this.termsAccepted.next(true);
	}

}
